import { type ReactNode } from 'react';

import styles from './ResourceDataTableContainer.module.css';

export const ResourceDataTableContainer = ({
  children,
}: {
  children: ReactNode;
}) => <div className={styles.root}>{children}</div>;
